import axiosHttpRequest from "../axios"

async function userLogoutDetails(endpoint, postedData, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postedData,
    configheaders
  );
  return serviceResponse;
}

async function resetLogin(endpoint, postedData, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postedData,
    configheaders
  );
  return serviceResponse;
}

export default {
  userLogoutDetails,
  resetLogin
};



